import React from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Container } from 'react-bootstrap';

function renderRegMailSent() {
    return (
        <>
            <Alert.Heading>Спасибо за регистрацию!</Alert.Heading>
            <p>
                На ваш адрес электроной почты было выслано письмо с кодом подтверждения. Для завершения процесса
                регистрации откройте письмо и перейдите по ссылке в нем.
            </p>
            <hr />
            <p>Если вы не получили письма, то</p>
            <ul>
                <li>проверьте папку Спам;</li>
                <li>подождите хотя бы час - возможно письмо еще не дошло;</li>
                <li>
                    повторите регистрацию, но уделите особое внимание тому, что указываете свой email правильно, либо
                    укажите другой;
                </li>
                <li>если ничего не помогло, напишите нам.</li>
            </ul>
        </>
    );
}

function renderResetMailSent() {
    return (
        <>
            <p>На указанный адрес электроной почты высланы логин и пароль.</p>
            <hr />
            <p>Если вы не получили письма, то</p>
            <ul>
                <li>проверьте папку Спам;</li>
                <li>подождите хотя бы час - возможно письмо еще не дошло;</li>
                <li>если ничего не помогло, напишите нам.</li>
            </ul>
        </>
    );
}

function renderContent(contentCode) {
    switch (contentCode) {
        case 'reg_mail_sent':
            return renderRegMailSent();
        case 'reset_mail_sent':
            return renderResetMailSent();
        default:
            return null;
    }
}

function MessagePage() {
    const { messCode } = useParams();
    return (
        <Container className="my-5">
            <Alert variant="info">{renderContent(messCode)}</Alert>
        </Container>
    );
}

export default MessagePage;
